<template>
  <div>
    <b-row style="margin-bottom:15px">
      <b-col lg="2">
        <b-form-select v-model="selectedYear" id="yearSelected" :options="yearOptions"></b-form-select>
      </b-col>
    </b-row>
    <b-row v-if="isLoading">
      <b-col>
        <LoadingSpinner></LoadingSpinner>
      </b-col>
    </b-row>
    <b-row v-if="!isLoading">
      <b-col>
        <b-tabs content-class="mt-3">
          <b-tab title="Lunes" active>
            <b-table sticky-header fixed striped no-border-collapse style="min-height: 65vh;" responsive
              :items="mondayItems" :fields="scheduleFields">
              <template #cell(AULA_1)="data">
                <div v-if="data.item.AULA_1">
                  <class-schedule :item="data.item.AULA_1" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_2)="data">
                <div v-if="data.item.AULA_2">
                  <class-schedule :item="data.item.AULA_2" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_3)="data">
                <div v-if="data.item.AULA_3">
                  <class-schedule :item="data.item.AULA_3" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_4)="data">
                <div v-if="data.item.AULA_4">
                  <class-schedule :item="data.item.AULA_4" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_5)="data">
                <div v-if="data.item.AULA_5">
                  <class-schedule :item="data.item.AULA_5" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_6)="data">
                <div v-if="data.item.AULA_6">
                  <class-schedule :item="data.item.AULA_6" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_7)="data">
                <div v-if="data.item.AULA_7">
                  <class-schedule :item="data.item.AULA_7" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_8)="data">
                <div v-if="data.item.AULA_8">
                  <class-schedule :item="data.item.AULA_8" :teachers="teachers"></class-schedule>
                </div>
              </template>
            </b-table>
          </b-tab>
          <b-tab title="Martes">
            <b-table responsive :items="tuesdayItems" :fields="scheduleFields">
              <template #cell(AULA_1)="data">
                <div v-if="data.item.AULA_1">
                  <class-schedule :item="data.item.AULA_1" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_2)="data">
                <div v-if="data.item.AULA_2">
                  <class-schedule :item="data.item.AULA_2" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_3)="data">
                <div v-if="data.item.AULA_3">
                  <class-schedule :item="data.item.AULA_3" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_4)="data">
                <div v-if="data.item.AULA_4">
                  <class-schedule :item="data.item.AULA_4" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_5)="data">
                <div v-if="data.item.AULA_5">
                  <class-schedule :item="data.item.AULA_5" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_6)="data">
                <div v-if="data.item.AULA_6">
                  <class-schedule :item="data.item.AULA_6" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_7)="data">
                <div v-if="data.item.AULA_7">
                  <class-schedule :item="data.item.AULA_7" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_8)="data">
                <div v-if="data.item.AULA_8">
                  <class-schedule :item="data.item.AULA_8" :teachers="teachers"></class-schedule>
                </div>
              </template>
            </b-table>
          </b-tab>
          <b-tab title="Miercoles">
            <b-table responsive :items="wednesdayItems" :fields="scheduleFields">
              <template #cell(AULA_1)="data">
                <div v-if="data.item.AULA_1">
                  <class-schedule :item="data.item.AULA_1" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_2)="data">
                <div v-if="data.item.AULA_2">
                  <class-schedule :item="data.item.AULA_2" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_3)="data">
                <div v-if="data.item.AULA_3">
                  <class-schedule :item="data.item.AULA_3" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_4)="data">
                <div v-if="data.item.AULA_4">
                  <class-schedule :item="data.item.AULA_4" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_5)="data">
                <div v-if="data.item.AULA_5">
                  <class-schedule :item="data.item.AULA_5" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_6)="data">
                <div v-if="data.item.AULA_6">
                  <class-schedule :item="data.item.AULA_6" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_7)="data">
                <div v-if="data.item.AULA_7">
                  <class-schedule :item="data.item.AULA_7" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_8)="data">
                <div v-if="data.item.AULA_8">
                  <class-schedule :item="data.item.AULA_8" :teachers="teachers"></class-schedule>
                </div>
              </template>
            </b-table>
          </b-tab>
          <b-tab title="Jueves">
            <b-table responsive :items="thursdayItems" :fields="scheduleFields">
              <template #cell(AULA_1)="data">
                <div v-if="data.item.AULA_1">
                  <class-schedule :item="data.item.AULA_1" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_2)="data">
                <div v-if="data.item.AULA_2">
                  <class-schedule :item="data.item.AULA_2" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_3)="data">
                <div v-if="data.item.AULA_3">
                  <class-schedule :item="data.item.AULA_3" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_4)="data">
                <div v-if="data.item.AULA_4">
                  <class-schedule :item="data.item.AULA_4" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_5)="data">
                <div v-if="data.item.AULA_5">
                  <class-schedule :item="data.item.AULA_5" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_6)="data">
                <div v-if="data.item.AULA_6">
                  <class-schedule :item="data.item.AULA_6" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_7)="data">
                <div v-if="data.item.AULA_7">
                  <class-schedule :item="data.item.AULA_7" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_8)="data">
                <div v-if="data.item.AULA_8">
                  <class-schedule :item="data.item.AULA_8" :teachers="teachers"></class-schedule>
                </div>
              </template>
            </b-table>
          </b-tab>
          <b-tab title="Viernes">
            <b-table responsive :items="thursdayItems" :fields="scheduleFields">
              <template #cell(AULA_1)="data">
                <div v-if="data.item.AULA_1">
                  <class-schedule :item="data.item.AULA_1" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_2)="data">
                <div v-if="data.item.AULA_2">
                  <class-schedule :item="data.item.AULA_2" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_3)="data">
                <div v-if="data.item.AULA_3">
                  <class-schedule :item="data.item.AULA_3" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_4)="data">
                <div v-if="data.item.AULA_4">
                  <class-schedule :item="data.item.AULA_4" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_5)="data">
                <div v-if="data.item.AULA_5">
                  <class-schedule :item="data.item.AULA_5" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_6)="data">
                <div v-if="data.item.AULA_6">
                  <class-schedule :item="data.item.AULA_6" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_7)="data">
                <div v-if="data.item.AULA_7">
                  <class-schedule :item="data.item.AULA_7" :teachers="teachers"></class-schedule>
                </div>
              </template>
              <template #cell(AULA_8)="data">
                <div v-if="data.item.AULA_8">
                  <class-schedule :item="data.item.AULA_8" :teachers="teachers"></class-schedule>
                </div>
              </template>
            </b-table>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
    <edit-class></edit-class>
  </div>
</template>

<script>
import editClass from '../components/pop-ups/editClass.vue'
import { CoursesService } from '@/services/courses.service'
// import { YearsService } from '@/services/years.service'
// import { RoomService } from '@/services/room.service'
import { TeacherService } from '@/services/teacher.service'
import ClassSchedule from '../components/schedule/classSchedule.vue'
// import { RoomService } from '@/services/room.service'
import { ScheduleService } from '@/services/schedule.service'
import { ClassesService } from '@/services/classes.service'
import LoadingSpinner from './../components/LoadingSpinner.vue'

export default {
  name: 'IndexPage',
  components: {
    ClassSchedule,
    editClass,
    LoadingSpinner
  },
  data () {
    return {
      isLoading: true,
      name: 'asd',
      rooms: [],
      classes: [],
      courses: [],
      schedule: {},
      teachers: {},
      items: [],
      years: [],
      editClassItem: {},
      selectedYear: null,
      verInscriptosList: [],
      pop_up_enrollments_ids: [],
      scheduleFields: ['hora', 'AULA 1', 'AULA 2', 'AULA 3', 'AULA 4', 'AULA 5', 'AULA 6', 'AULA 7', 'AULA 8'],
      mondayItems: [],
      tuesdayItems: [],
      wednesdayItems: [],
      thursdayItems: [],
      fridayItems: []
    }
  },
  watch: {
    selectedYear: 'handleYearChange'
  },
  computed: {
    yearOptions () {
      const opts = []
      for (var i = 0; i < this.years.length; i++) {
        opts.push({ value: this.years[i].id, text: this.years[i].x_year })
      }
      return opts
    }
  },

  async created () {
    if (this.$store.state.schedule.date === null) {
    }

    this.isLoading = true
    this.years = this.$store.state.year.list
    this.year = this.$store.state.year.selected
    this.courses = await CoursesService.list({})
    this.teachers = await TeacherService.list({})
    await this.handleYearChange()
    await this.updateSchedule()
    this.selectedYear = this.year.id
    this.isLoading = false

    // Fetch teachers and update the teachers object
    const teachers = await TeacherService.list({})
    this.teachers = {}
    for (let i = 0; i < teachers.length; i++) {
      if (!teachers[i].x_color) {
        this.teachers[teachers[i].id] = { backgroundColor: 'white', color: 'dark' }
      } else {
        this.teachers[teachers[i].id] = { backgroundColor: teachers[i].x_color, color: 'white' }
      }
    }
    // this.rooms = await RoomService.list()
    // console.log(this.$store.schedule)
  },

  methods: {
    verClase (id) {
      const routeData = this.$router.push()
      window.open(routeData.href, '_blank')
    },
    async editarClase (item) {
      this.editClassItem = item
      this.$bvModal.show('edit-clase')
    },
    async handleYearChange () {
      // Store the selected year in a temporary variable
      const selectedYear = this.selectedYear
      // Use nextTick to wait for the DOM to update
      this.$nextTick(async () => {
        // Check if the stored year is still the same as the current selected year
        if (selectedYear === this.selectedYear) {
          this.updateSchedule()
        }
      })
    },

    async updateSchedule () {
      this.isLoading = true

      this.schedule = []
      this.mondayItems = []
      this.tuesdayItems = []
      this.wednesdayItems = []
      this.thursdayItems = []
      this.fridayItems = []

      let values = []
      try {
        // Fetch classes based on the selected year
        this.classes = await ClassesService.list({ x_year_id: this.selectedYear })
        // Fetch schedules for each class
        const promises = this.classes.map((classItem) => ScheduleService.list({ x_class_id: classItem.id }))
        values = await Promise.all(promises)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
      // Arrange the schedule classes
      try {
        await Promise.all(values.map(async (classSchedules, i) => {
          for (let j = 0; j < classSchedules.length; j++) {
            const item = classSchedules[j]
            item.class = this.classes[i]
            if (this.schedule[item.x_day_of_week] === undefined) {
              this.schedule[item.x_day_of_week] = {}
            }
            if (this.schedule[item.x_day_of_week][item.x_start_time] === undefined) {
              this.schedule[item.x_day_of_week][item.x_start_time] = {}
            }
            if (this.rooms[item.x_room_id[1]] === undefined) {
              this.rooms[item.x_room_id[1].replace(' ', '_')] = true
            }
            this.schedule[item.x_day_of_week][item.x_start_time][item.x_room_id[1].replace(' ', '_')] = item
          }
        }))
        // console.log('values: ', values)
      } catch (error) {
        console.error('Error updating schedule:', error)
      }

      if (this.schedule.monday !== undefined) {
        let mondayTimes = Object.keys(this.schedule.monday)
        console.log('schedule monday: ', this.schedule.monday)
        mondayTimes = mondayTimes.sort()
        for (let i = 0; i < mondayTimes.length; i++) {
          this.mondayItems.push({ hora: mondayTimes[i], ...this.schedule.monday[mondayTimes[i]] })
        }
      }
      console.log('monday times global', this.mondayItems)
      if (this.schedule.tuesday !== undefined) {
        let tuesdayTimes = Object.keys(this.schedule.tuesday)
        tuesdayTimes = tuesdayTimes.sort()
        for (let i = 0; i < tuesdayTimes.length; i++) {
          this.tuesdayItems.push({ hora: tuesdayTimes[i], ...this.schedule.tuesday[tuesdayTimes[i]] })
        }
      }

      if (this.schedule.wednesday !== undefined) {
        let wednesdayTimes = Object.keys(this.schedule.wednesday)
        wednesdayTimes = wednesdayTimes.sort()
        for (let i = 0; i < wednesdayTimes.length; i++) {
          this.wednesdayItems.push({ hora: wednesdayTimes[i], ...this.schedule.wednesday[wednesdayTimes[i]] })
        }
      }

      if (this.schedule.thursday !== undefined) {
        let thursdayTimes = Object.keys(this.schedule.thursday)
        thursdayTimes = thursdayTimes.sort()
        for (let i = 0; i < thursdayTimes.length; i++) {
          this.thursdayItems.push({ hora: thursdayTimes[i], ...this.schedule.thursday[thursdayTimes[i]] })
        }
      }

      if (this.schedule.friday !== undefined) {
        let fridayTimes = Object.keys(this.schedule.friday)
        fridayTimes = fridayTimes.sort()
        for (let i = 0; i < fridayTimes.length; i++) {
          this.fridayItems.push({ hora: fridayTimes[i], ...this.schedule.friday[fridayTimes[i]] })
        }
      }

      this.scheduleFields = ['hora', ...Object.keys(this.rooms).sort()]
      console.log(this.scheduleFields)
      this.isLoading = false
    }
  }
}
</script>

<style lang="scss" scoped>
.table td {
  padding: 0
}
</style>
